class AthleteGrid extends HTMLElement {
  constructor() {
    super();
    this.containerSelector = this.getAttribute('data-container');
    this.storefrontApiToken = this.getAttribute('data-storefront-api-token');
    this.featuredClass = 'athlete-card--featured';
    this.grid = this.querySelector(this.containerSelector);
    if (this.containerSelector) {
      this.mutationObserver = new MutationObserver(this.reorderGridItems.bind(this));
      this.observeGridChanges();
    }

    // Ensure items are reordered on page load
    document.addEventListener('DOMContentLoaded', () => {
      if (this.grid) {
        this.reorderGridItems();
      }
    });
  }

  connectedCallback() {
    this.reorderGridItems();
  }

  reorderGridItems() {
    this.mutationObserver.disconnect();
    const items = Array.from(this.grid.querySelectorAll('.grid__item'));
    const featuredItems = items.filter((item) => item.classList.contains(this.featuredClass));
    const nonFeaturedItems = items.filter((item) => !item.classList.contains(this.featuredClass));

    let reorderedItems = [];
    let smallItemCount = 0;

    while (nonFeaturedItems.length > 0 || featuredItems.length > 0) {
      for (let i = 0; i < 4 && nonFeaturedItems.length > 0; i++) {
        reorderedItems.push(nonFeaturedItems.shift());
        smallItemCount++;
      }

      if (featuredItems.length > 0 && smallItemCount % 4 === 0) {
        reorderedItems.push(featuredItems.shift());
      }
    }

    this.applyGridRowPositions(reorderedItems);

    reorderedItems = reorderedItems.concat(nonFeaturedItems);
    this.updateGridOrder(reorderedItems);

    this.mutationObserver.observe(this.grid, { childList: true, subtree: false });
  }

  applyGridRowPositions(reorderedItems) {
    let rowStart = 1;
    let featuredItemCount = 0;

    reorderedItems.forEach((item) => {
      if (item.classList.contains(this.featuredClass)) {
        item.style.gridRowStart = rowStart;
        item.style.gridRowEnd = rowStart + 2;

        if (featuredItemCount % 2 === 0) {
          item.style.gridColumnStart = '3';
          item.style.gridColumnEnd = '5';
        } else {
          item.style.gridColumnStart = '1';
          item.style.gridColumnEnd = '3';
        }

        featuredItemCount++;
        rowStart += 3; // Increment rowStart for each subsequent featured item (1, 4, 7, 10...)
      }
    });
  }

  updateGridOrder(reorderedItems) {
    this.grid.innerHTML = '';

    reorderedItems.forEach((item) => {
      this.grid.appendChild(item);
    });
  }

  observeGridChanges() {
    const config = { childList: true, subtree: false };
    this.mutationObserver.observe(this.grid, config);
  }
}

customElements.define('athlete-grid', AthleteGrid);
